<template>
	<div class="contestTableTab">
		<v-card flat>
			<v-data-table v-if="finished === false"
				hide-actions
				:headers="dataTable.tableHeadersAnnounced"
				:loading="loading"
				:rows-per-page-items="[10,20,25]"
				:items="dataTable.itemList"
				:total-items="dataTable.itemCount"
				:pagination.sync="dataTable.pagination"
				class="elevation-1">
				<template slot="items" slot-scope="props">
					<td v-if="props.item.contestPage"><a target="_blank" :href="'https://' + props.item.contestPage"
						style="font-weight: bold; text-decoration: none"> {{ props.item.name }} </a></td>
					<td v-else
						style="font-weight: bold; text-decoration: none"> {{ props.item.name }}
					</td>
					<td>{{ props.item.contestStartDateTime }}</td>
					<td>{{ props.item.contestEndDateTime }}</td>
					<td v-if="pdfAvailable(props.item)" align="left">
						<v-btn medium-small class="mr-2" icon @click="goToEmptyOffer(props.item.id)">
							<v-icon>file_copy</v-icon>
						</v-btn>
					</td>
					<td v-else style="color: accent">Trwa ocena ofert</td>
				</template>
			</v-data-table>

			<v-data-table v-else
				hide-actions
				:headers="dataTable.tableHeadersFinished"
				:rows-per-page-items="[10,20,25]"
				:loading="loading"
				:items="dataTable.itemList"
				:total-items="dataTable.itemCount"
				:pagination.sync="dataTable.pagination"
				class="elevation-1">
				<template slot="items" slot-scope="props">
					<td v-if="props.item.contestPage"><a target="_blank" :href="'https://' + props.item.contestPage"
						style="font-weight: bold; text-decoration: none"> {{ props.item.name }} </a></td>
					<td v-else
						style="font-weight: bold; text-decoration: none"> {{ props.item.name }}
					</td>
					<td>{{ props.item.contestStartDateTime }}</td>
					<td>{{ props.item.contestEndDateTime }}</td>
					<td v-if="props.item.resultPage">
						<a target="_blank" :href="'https://' + props.item.resultPage"
							style="color: accent; text-decoration: none">Sprawdź</a></td>
					<td v-else><span>-</span></td>
				</template>
			</v-data-table>
			<div class="text-xs-center pt-2">
				<v-pagination v-model="dataTable.pagination.page" :length="pages" total-visible="5"></v-pagination>
			</div>

		</v-card>
	</div>
</template>

<script>
	import {Api} from "../../../api";

	export default {
		name: "ContestTableTab",

		watch: {
			"dataTable.pagination.page": function () {
				this.getItemList();
			},
		},

		computed: {
			pages() {
				if (this.dataTable.pagination.rowsPerPage === undefined) {
					return 0;
				}
				return Math.ceil(this.dataTable.itemCount / this.dataTable.pagination.rowsPerPage);
			},
		},

		mounted() {
			this.removeEmptyTableLoading();
		},

		props: {
			finished: Boolean,
		},

		methods: {
			getItemList() {
				this.dataTable.search = "finished::" + this.finished + "$$";
				Api.get(this,
					"/announced-contest/list?search=" + this.dataTable.search
						+ "&page=" + this.dataTable.pagination.page +
						"&result=" + this.dataTable.pagination.rowsPerPage, response => {
							this.dataTable.itemList = response.itemList;
							this.dataTable.itemCount = response.itemCount;
							Array.prototype.forEach.call(this.dataTable.itemList, contest => {
								let prefixPattern = new RegExp("https?://");
								let url = contest.contestPage;
								if (prefixPattern.test(url)) {
									url = url.substr(url.indexOf("/") + 2);
									contest.contestPage = url;
								}
								url = contest.resultPage;
								if (prefixPattern.test(url)) {
									url = url.substr(url.indexOf("/") + 2);
									contest.resultPage = url;
								}
							});
						});
			},

			formatDate(date) {
				let mm = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
				let dd = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
				let hrs = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
				let min = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
				return date.getFullYear() + "-" + mm + "-" + dd + " " + hrs + ":" + min;
			},

			pdfAvailable(item) {
				return item.contestStatus === 'ANNOUNCED';
			},

			goToEmptyOffer (id) {
				this.$router.push("empty-offer/" + id);
			},

			removeEmptyTableLoading() {
				var el = document.querySelector('.v-datatable__progress');
				el.parentNode.removeChild(el);
			}
		},

		data() {
			return {
				dataTable: {
					tableHeadersAnnounced: [
						{text: "Nazwa konkursu", sortable: false},
						{text: "Składanie od", sortable: false},
						{text: "Składanie do", sortable: false},
						{text: "Podgląd", sortable: false},
					],
					tableHeadersFinished: [
						{text: "Nazwa konkursu", sortable: false},
						{text: "Składanie od", sortable: false},
						{text: "Składanie do", sortable: false},
						{text: "Wynik", sortable: false},
					],
					itemList: [],
					itemCount: 0,
					pagination: {
						rowsPerPage: 25,
						sortBy: null
					},
				},

				loading: false,
			};
		},
	};
</script>

<style scoped>

</style>
